import React from 'react';
import { observer } from 'mobx-react-lite';
import { Div, Img, Spanner, Typography } from '@icecreamsocial/components';
import ForbiddenImg from '../../../assets/scoops-403.svg';
import { CompanyLogoLink } from '../../containers';
import { PageMeta } from '../../presentational';
import { HeaderPortal } from '../Main';

const Forbidden = () => {
	return (
		<>
			<PageMeta
				title="Access Denied | Ice Cream Social"
				description="Log into your admin account"
			/>
			<HeaderPortal>
				<Div backgroundColor="#EBEBEB" textAlign="center" padding="md">
					<Spanner grid gridColumns="repeat(3, 1fr)" padding="0">
						<Div display="flex" alignItems="center">
							<CompanyLogoLink />
						</Div>
						<Div display="flex" alignItems="center">
							<Div elWidth="100%" textAlign="center">
								<Typography.Span typoWeight="bold">
									Ice Cream Social
								</Typography.Span>
							</Div>
						</Div>
					</Spanner>
				</Div>
			</HeaderPortal>
			<Div
				elWidth={['100%', '66%', '50%']}
				margin="auto"
				marginTop="xlg"
				marginBottom="xlg"
				padding="lg"
			>
				<Img src={ForbiddenImg} />
				<Div textAlign="center">
					<Typography.H3>Oops, you shouldn't be here</Typography.H3>
					<Typography.Span>
						You don't have permission to access this area of the site
					</Typography.Span>
				</Div>
			</Div>
		</>
	);
};

Forbidden.displayName = 'Forbidden';

export default observer(Forbidden);
